import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-fontawesome-pro',
	templateUrl:'./FontAwesomeProPluginPage.html',
	styles: [],
	styleUrls:['./FontAwesomeProPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomeProPluginPage
{
	mdContent_99 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>font-awesome-pro</artifactId>
</dependency>
\`\`\``;
	mdContent_100 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:font-awesome-pro:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_101 = `\`\`\`json
"@fortawesome/pro-solid-svg-icons": "^7.2.0"
"@fortawesome/pro-regular-svg-icons": "^7.2.0"
"@fortawesome/pro-light-svg-icons": "^7.2.0"
"@fortawesome/pro-thin-svg-icons": "^7.2.0"
"@fortawesome/pro-duotone-svg-icons": "^7.2.0"
\`\`\``;
	mdContent_102 = `\`\`\`java
// Pro Regular icon
FontAwesome icon = IFontAwesome.createIcon(
    FontAwesomeIcons.user,
    FontAwesomeStyles.Regular);

// Pro Light icon
FontAwesome light = IFontAwesome.createIcon(
    FontAwesomeIcons.heart,
    FontAwesomeStyles.Light);

// Pro Duotone icon
FontAwesome duo = IFontAwesome.createIcon(
    FontAwesomeIcons.bell,
    FontAwesomeStyles.Duotone);
\`\`\``;
	mdContent_103 = `\`\`\`java
// Pro Regular icon
FontAwesome icon = IFontAwesome.createIcon(
    FontAwesomeIcons.user,
    FontAwesomeStyles.Regular);

// Pro Light icon
FontAwesome light = IFontAwesome.createIcon(
    FontAwesomeIcons.heart,
    FontAwesomeStyles.Light);

// Pro Duotone icon
FontAwesome duo = IFontAwesome.createIcon(
    FontAwesomeIcons.bell,
    FontAwesomeStyles.Duotone);
\`\`\``;
}
